<div class="list-contain modern" *ngIf="show">
    <div class="item_container modern">
        <ng-container *ngFor="let item of items; index as i">
            <ng-container>
                <app-card class="ex ex--modern pointer" [item]="item" viewType="modern"></app-card>
            </ng-container>
            <ng-container *ngIf="bannerPosition && bannerPosition[i] && banner?.id">
                <app-banner class="ex ex--modern" [ngClass]="{'pointer': banner?.link?.trim() && banner?.link?.trim() !== 'https://' && banner?.link?.trim() !== 'http://' && banner?.link?.trim() !== banner?.url?.trim()}" [banner]="banner" viewType="modern"></app-banner>
            </ng-container>
        </ng-container>
    </div>
</div>
